export default class SearchResult {
    constructor(data) {
        this.data = data;
        this.element = document.createElement('div');
        this.element.className = 'search-result';
    }

    render(parent) {
        const { icon, category, url, primary_link, service, highlighted } = this.data

        this.element.innerHTML = `
        <h3 class="font-bold flex justify-between">
            <div class="info flex flex-col justify-between items-start">
                ${url ? `<a class="block" href="${url}">${highlighted}</a>` : `<span class="block incomplete" title="Profile currently incomplete">${highlighted}</span>`}
                <span class="category text-sm bg-gray-300 px-2 py-0.5 uppercase rounded text-gray-600">${category}</span>
            </div>
            <ul class="wp-block-social-links has-normal-icon-size is-style-default mb-0">
                <li class="wp-social-link wp-social-link-${service} wp-block-social-link">
                    <a class="text-2xl" href="${primary_link}">${icon}</a>
                </li>
            </ul>
        </h3>
        `;

        parent.appendChild(this.element);
    }
}